import { withErrorBoundary } from "@sentry/react";

import ErrorFallback from "@components/error-fallback/error-fallback";

import AskAIEmbedOverviewUser from "./ask-ai-embed-overview-user";
import { OverviewUserPlaceholderType } from "./ask-ai-placeholders";

const AskAIPlaceholderOverviewUser = ({
  overviewUser,
}: {
  overviewUser: OverviewUserPlaceholderType | null;
}) => {
  if (!overviewUser)
    return (
      <div className="flex gap-2 items-center">
        <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-5 w-5" />
        <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-5 w-36" />
        <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-5 flex-1" />
      </div>
    );

  return <AskAIEmbedOverviewUser overviewUser={overviewUser} />;
};

export default withErrorBoundary(AskAIPlaceholderOverviewUser, {
  fallback: ErrorFallback,
});
